/*!
 * @jusda-tools/web-api-client 1.0.1-alpha.0 (https://github.com/wfc/jusda-tools-web-api-client)
 * API https://github.com/wfc/jusda-tools-web-api-client/blob/master/doc/api.md
 * Copyright 2017-2024 wfc. All Rights Reserved
 * Licensed under MIT (https://github.com/wfc/jusda-tools-web-api-client/blob/master/LICENSE)
 */

import request from 'umi-request';
export { default, extend } from 'umi-request';
import { CookieTools } from '@jusda-tools/jusda-publicmethod';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const cookieTools = new CookieTools();
function addFieldsForAuthentication() {
    let authFields = {};
    const token = cookieTools.getToken() || '';
    //@ts-ignore
    const { clientId = '' } = window.jusdaBaseConfig || {};
    if (token) {
        authFields = {
            authorization: `Bearer ${token}`,
            clientId,
        };
    }
    return authFields;
}
request.use((ctx, next) => __awaiter(void 0, void 0, void 0, function* () {
    ctx.req.options = Object.assign(Object.assign({}, ctx.req.options), { headers: Object.assign(Object.assign({}, addFieldsForAuthentication()), ctx.req.options.headers) });
    return next();
}), { global: true });
